// extracted by mini-css-extract-plugin
module.exports = {"change-tabs":"TableSection_change-tabs__EwPr5","active":"TableSection_active__2D_6h","activate":"TableSection_activate__1NkTf","dropdown-btn":"TableSection_dropdown-btn__1Ybx1"};